export default "__VITE_ASSET__Dxz$QYW0__"